import {Header, Footer} from '@baidu/qianfan-portal-common';
import '@baidu/qianfan-portal-common/esm/index.css';
import {useEffect, useRef, useState} from 'preact/hooks';
import {throttle} from 'lodash';

import {useScrollToAnchor, isMobile} from '~/utils';
import {getBceAuthInfo} from 'utils';
import {
    Banner,
    // Header,
    // Footer,
    ModelServices,
    ModelCenter,
    MoreModelServices,
    AppBuilder,
    Application,
    Practice,
    Resource,
    Questionnaire
} from '~/components/sections/qianfan/index';
import {headerSdk, footerSdk} from '~/locals/qianfan/index';
import '~/style/qianfan/index.less';

const {columns, qrCodes, copyRight} = footerSdk;
const moduleTitleClassName = 'qf-module-title';
const moduleDescClassName = 'qf-module-desc';
const moduleContentClassName = 'qf-module-content';

export default function Wenxin() {
    const [userInfo, setUserInfo] = useState();
    const navContentRef = useRef(null);
    const bannerRef = useRef(null);
    const {menuList, logoInfo} = headerSdk;

    /** 判断是否在视窗下方 */
    const isBelowViewport = element => {
        if (!element) {
            return false;
        }
        const rect = element.getBoundingClientRect();
        return rect.top > window.innerHeight;
    };

    useEffect(() => {
        const titleList = document.querySelectorAll(`.${moduleTitleClassName}`);
        const descList = document.querySelectorAll(`.${moduleDescClassName}`);
        const contentList = document.querySelectorAll(`.${moduleContentClassName}`);

        const nodeList = [...titleList, ...descList, ...contentList];
        // 实现视窗下模块动画展示效果
        const handleAnimationEffect = () => {
            if (isMobile()) {
                nodeList.forEach(item => {
                    item.classList.remove('qf-below-module');
                });
                return;
            }

            nodeList.forEach(item => {
                if (isBelowViewport(item)) {
                    item.classList.add('qf-below-module');
                } else {
                    item.classList.remove('qf-below-module');
                }
            });
        };
        const throttleHandleAnimationEffect = throttle(handleAnimationEffect, 100);
        window.addEventListener('scroll', throttleHandleAnimationEffect);
        window.addEventListener('resize', throttleHandleAnimationEffect);
        return () => {
            window.removeEventListener('scroll', throttleHandleAnimationEffect);
            window.removeEventListener('resize', throttleHandleAnimationEffect);
        };
    }, []);

    return (
        <>
            <Header logo={logoInfo} menus={menuList} />
            <div className="qianfan-page no_rem_qianfan-page">
                {/* <Header bannerRef={bannerRef} navContentRef={navContentRef} userInfo={userInfo} type="total" /> */}
                <div className="long-bg">
                    <Banner ref={bannerRef} />
                    <ModelCenter />
                </div>
                <AppBuilder />
                <Application />
                <Practice />
                <Resource />
                <ModelServices />
                <MoreModelServices />
                <Footer columns={columns} qrCodes={qrCodes} copyRight={copyRight} />
                <Questionnaire />
            </div>
        </>
    );
}
